import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import 'flowbite';
import './index.css'
import "../public/videojs/mockup/videojs.min.css"
import Toast from 'vue-toastification'
import 'maz-ui/styles'
import * as Sentry from "@sentry/vue";

import 'vue-toastification/dist/index.css'

const options = { 
    timeout: 5000,
    position: 'top-center',
    closeOnClick: true,
    showCloseButtonOnHover: true,
    pauseOnHover: true,
    containerClassName: 'custom-toast-container',
};
const pinia = createPinia()
const app = createApp(App);
Sentry.init({
  app,
  dsn: "https://74d570155723a4ee22f25b5a36d48a45@o4510510842839040.ingest.us.sentry.io/4510511061008384", 
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration()
  ],
  tracesSampleRate: 1.0, 
  tracePropagationTargets: ["localhost", /^https:\/\/api.nasna.tv\/api/],
  replaysSessionSampleRate: 0.1, 
  replaysOnErrorSampleRate: 1.0, 
  enableLogs: true
});

app.use(pinia).use(Toast, options).use(router).mount('#app')
